import { isDefined } from "@clipboard-health/util-ts";
import { type Theme } from "@mui/material";

export type CompatibleColor =
  | ((theme: Theme) => string | undefined) /* MUI v5 */
  | string /* MUI v6 */;

export function getCompatibleColor(props: {
  color?: CompatibleColor;
  defaultColor: string;
  theme: Theme;
}): string {
  const { color, defaultColor, theme } = props;

  if (typeof color === "function") {
    return color(theme) ?? defaultColor;
  }

  if (isDefined(color)) {
    return color;
  }

  return defaultColor;
}
